/**
 * @fileoverview POST handler for the "/engagement/update_feature_flag_rollout_archived_state" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementUpdateFeatureFlagRolloutArchivedStateCacheKeys } from "./constants";
import type {
  PostEngagementUpdateFeatureFlagRolloutArchivedStateProps,
  EngagementUpdateFeatureFlagRolloutArchivedStateResult,
} from "./types";

export const postEngagementUpdateFeatureFlagRolloutArchivedState = reactQueryMutationAdapter(
  engagementUpdateFeatureFlagRolloutArchivedStateCacheKeys,
  (
    props: PostEngagementUpdateFeatureFlagRolloutArchivedStateProps
  ): Promise<EngagementUpdateFeatureFlagRolloutArchivedStateResult> => {
    return fetch("/engagement/update_feature_flag_rollout_archived_state", "POST", props);
  }
);
